export const GET_WORKFLOW = 'GET_WORKFLOW';
export const GET_WORKFLOW_EXTRACT = 'GET_WORKFLOW_EXTRACT';
export const GET_FILE_EXTRACT = 'GET_FILE_EXTRACT';
export const GET_WORKFLOW_BY_ID = 'GET_WORKFLOW_BY_ID';
export const GET_AUTO_EXTRACT_STATUSES = 'GET_AUTO_EXTRACT_STATUSES';
export const GET_TEMPLATE = 'GET_TEMPLATE';
export const GET_SHEET = 'GET_SHEET';
export const GET_TRANSFORM = 'GET_TRANSFORM';
export const GET_HEADER_FOOTER = 'GET_HEADER_FOOTER';
export const GET_FUND_MAPPINGS = 'GET_FUND_MAPPINGS';
export const GET_FUNDS_BY_PERIOD = 'GET_FUNDS_BY_PERIOD';
export const GET_CUSTOM_FIELDS = 'GET_CUSTOM_FIELDS';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_EXTRACTION_STATS = 'GET_EXTRACTION_STATS';
export const GET_TRANSFORMATION_STATS = 'GET_TRANSFORMATION_STATS';
export const GET_OUTPUT_TABLES_STATS = 'GET_OUTPUT_TABLES_STATS';
